import { render, staticRenderFns } from "./CancelacionMasiva.vue?vue&type=template&id=685ee3ce&"
import script from "./CancelacionMasiva.vue?vue&type=script&lang=js&"
export * from "./CancelacionMasiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports